import styled from 'styled-components';
import Calendar from 'react-calendar';

interface ICalendarProps {
  isOffboarding?: boolean;
}

export const StyledCalendar = styled(Calendar)<ICalendarProps>`
  ${({ theme, isOffboarding }) => `
    border-radius: 12px;
    background: #DBD9FF;
    .react-calendar {
      width: 100%;
    }
    .react-calendar__navigation {
      display: flex;      
      justify-content: end;
      margin-bottom: 8px;        
      align-items: center;
      max-width: 90%;
    }
    .react-calendar__navigation button {
      color: ${theme.uptimeColors.grayScales.white};
      border: none;
      max-width: 55%;
      padding: 4px 2px;
      font-size: ${isOffboarding ? '14px' : '10px'};
      border-radius: 18px;
      flex: 0 0 auto;
      font-weight: 600;
      letter-spacing: 0.594px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .react-calendar__navigation__label {
      background: ${theme.uptimeColors.mainTheme.primary};
      order: 1;
      flex-grow: 0;
      min-width: 95px !important;
    }
    
    .react-calendar__navigation__arrow {
      background: none;
    }
    .react-calendar__navigation__prev-button {
      order: 2;
      cursor: pointer;
    }

    .react-calendar__navigation__prev-button svg {
      border-radius: 50% !important;
      width: ${isOffboarding ? '24px' : '16px'};
      height: ${isOffboarding ? '24px' : '16px'};
      background: #A7AFCB !important;
    }
    .react-calendar__navigation__next-button {
      order: 3;
      cursor: pointer;
    }

    .react-calendar__navigation__next-button svg {
      border-radius: 50% !important;
      width: ${isOffboarding ? '24px' : '16px'};
      height: ${isOffboarding ? '24px' : '16px'};
      background: #A7AFCB !important;
    }
   
    .react-calendar__month-view__weekdays {
      text-align: center;
      color: ${theme.uptimeColors.grayScales.darkGray};
      font-weight: 600;
      text-transform: uppercase;
      abbr[title] {
          text-decoration: none;
      };
      font-size: ${isOffboarding ? '14px' : '10px'};
      line-height: 19px;
    }
   
    .react-calendar__month-view__days {
      font-size: ${isOffboarding ? '14px' : '10px'};
      font-weight: 400;
    }
    .react-calendar__tile {  
      background: none;     
      color: ${theme.uptimeColors.mainTheme.primary};
      text-align: center;
      height: ${isOffboarding ? '34px' : '24px'};
      border: none;
      margin: 2px 0px;
    }
    .react-calendar__month-view__days__day--weekend {
      border-radius: 18px 0px 0px 18px;
    }
    .react-calendar__tile--active {
      background: #F0F0F0;
    }
    .react-calendar__tile--rangeStart {
      position: relative;
      z-index: 0;
      color: #FFFF;
      &:before {
        display: block;
        position: absolute;
        content: '';
        left: 50%;
        right: 0;
        bottom: 0;
        top: 0;
        background: #F0F0F0;
        z-index: -1;
      }
      
      &:after {
        display: block;
        position: absolute;
        content: '';
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        background: linear-gradient(0deg, #5F249F 0%, #A2DDF8 100%);
        z-index: -1;
        border-radius: 50%;
      }
    }
    .react-calendar__tile--rangeEnd {
      position: relative;
      z-index: 0;
      color: #FFFF;
      &:before {
        display: block;
        position: absolute;
        content: '';
        left: 0;
        right: 50%;
        bottom: 0;
        top: 0;
        background: #F0F0F0;
        z-index: -1;
      }
      
      &:after {
        display: block;
        position: absolute;
        content: '';
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        background: linear-gradient(0deg, #5F249F 0%, #A2DDF8 100%);
        z-index: -1;
        border-radius: 50%;
      }
    }
    .react-calendar__tile--rangeBothEnds {
      border-radius: 18px;
    }
    .react-calendar__tile:disabled {
      background: #DBD9FF;
    }

    .react-calendar__month-view__days__day:not(.react-calendar__month-view__days__day--weekend)
      + .react-calendar__month-view__days__day--weekend {
        border-radius: 0px 18px 18px 0px;
    }

  @media screen and (max-width: ${theme.breakpoints.md}) {
     .react-calendar__tile--rangeStart {     
      &:after {       
        border-radius: 18px;
      }
    }
    .react-calendar__tile--rangeEnd {           
      &:after {       
        border-radius: 18px;
      }
    }
  }
`}
`;
